import React from 'react';
import { FetchablePersonInfoCard, PersonInfoCardModifier } from '../PersonInfoCard';
import { Tooltip, TooltipPlacement } from '../../atoms/Tooltip';
import { Image, ImageModifier } from '../Image';
import { CollapsibleContentPortal } from '../../organisms/CollapsibleOverlay/CollapsibleOverlay';
import { CollapsibleModifier } from '../../organisms/CollapsibleOverlay/CollapsibleOverlay.modifier';
import useCollapsibleOverlay from '../../../hooks/useCollapsibleOverlay';
import { ProfileImageSmall } from '../../../types/api/ImageType';
import IUrl from '../../../types/IUrl';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type PersonProfileImageSmallInfoCardProps = {
  personInfoCardUrl: IUrl;
  profileName?: string;
  profileImageUrl: ProfileImageSmall;
};

/**
 * Displays a user image if a profilePic with the collapsible Infocard.
 */
export function PersonProfileImageSmallInfoCard({
  profileImageUrl,
  personInfoCardUrl,
  profileName,
}: PersonProfileImageSmallInfoCardProps) {
  const { t } = useSonTranslation('PersonProfileImageSmall');
  const { collapsibleProps, toggleProps } = useCollapsibleOverlay('right');

  const businessCardPrefix = t(`businessCardPrefix`) + profileName;

  return (
    <div className="person-profile-image-small">
      <Tooltip attachTo={toggleProps.ref} placement={TooltipPlacement.TOP} hideOnClick>
        <button
          type="button"
          className="person-profile-image-small__container"
          title={businessCardPrefix}
          {...toggleProps}
        >
          <span className="person-profile-image-small__pic">
            <Image
              image={profileImageUrl}
              customAltText={businessCardPrefix}
              modifier={ImageModifier.WIDTH_HEIGHT_100}
              lazyLoading
            />
          </span>
        </button>
      </Tooltip>
      <CollapsibleContentPortal {...collapsibleProps} modifier={CollapsibleModifier.PERSON_PROFILE_IMAGE_SMALL}>
        <FetchablePersonInfoCard
          modifier={PersonInfoCardModifier.FIXED_SIZE}
          personInfoCardUrl={personInfoCardUrl.url}
        />
      </CollapsibleContentPortal>
    </div>
  );
}
